import * as React from "react";
import {
    Button,
    Dialog,
    DialogActions,
    DialogContent,
    DialogTitle,
    Typography,
} from "@mui/material";
import {useTranslation} from "react-i18next";

interface DeleteConfirmDialogProps {
    open: boolean;
    isDeleting: boolean;
    onCancel: () => void;
    onConfirm: () => void;
}

export default function DeleteConfirmDialog({
    open,
    isDeleting,
    onCancel,
    onConfirm,
}: DeleteConfirmDialogProps): React.ReactElement {
    const {t} = useTranslation();
    return (
        <Dialog
            open={open}
            onClose={() => {
            }}
            disableEscapeKeyDown
            aria-labelledby="delete-confirmation-dialog-title"
            aria-describedby="delete-confirmation-dialog-description"
        >
            <DialogTitle id="delete-confirmation-dialog-title">
                {t('payroll.period.deleteSnapshot')}
            </DialogTitle>
            <DialogContent>
                <Typography variant="body1" gutterBottom>
                    {t('payroll.period.confirm.deleteSnapshot')}
                </Typography>
            </DialogContent>
            <DialogActions>
                <Button onClick={onCancel} color="primary">
                    {t('common.actions.cancel')}
                </Button>
                <Button
                    onClick={onConfirm}
                    color="error"
                    variant="contained"
                    disabled={isDeleting}
                >
                    {isDeleting ? t('payroll.period.deletingSnapshot') : t('payroll.period.deleteSnapshot')}
                </Button>
            </DialogActions>
        </Dialog>
    );
}
